import { CollapsePanelTitle } from '../captions/collapse-panel-title';
import { HelpCenterContent } from '../help-center-content';
import { WistiaPlayer } from '../player/wistia-player';

export const QuoteHelpCenterContent = () => {
  return (
    <HelpCenterContent
      helpCaptionTitle="Help with Quote Module"
      panelItems={[
        {
          // cspell:ignore o67ukilu5m
          children: <WistiaPlayer mediaId="o67ukilu5m" />,
          key: '1',
          label: <CollapsePanelTitle>How to use the Quote Module</CollapsePanelTitle>,
        },
      ]}
    />
  );
};
